import Vue from 'vue';
import Vuex from 'vuex';
import echartsMap from '@/store/echartsMap/echartsMap';
import chinaMap from '@/store/chinaMap/chinaMap';
import login from '@/store/login/login';
import news from '@/store/news/news'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    ordinaryLoggedIn: JSON.parse(localStorage.getItem('ordinaryLoggedIn')) || false,
    ordinaryWsConnected: false,
    ordinaryUser: JSON.parse(localStorage.getItem('ordinaryUser')) || '', // 主页用户
    supervisionLoggedIn: JSON.parse(localStorage.getItem('supervisionLoggedIn')) || false,
    supervisionUser:
      JSON.parse(localStorage.getItem('supervisionUser')) || '', // 监管用户
    supervisionWsConnected: false,
    windowSize: null, // 当前窗口宽度
    routerClickStatus:0, // 记录路由被点击的变化
  },
  mutations: {
    updateRouterClickStatus(state, payload) {
      state.routerClickStatus++;
      localStorage.setItem('routerPath',payload)
    },
    updateWindowSize(state, payload) {
      state.windowSize = payload;
    },
    changeOrdinaryUser(state, data) {
      state.ordinaryUser = data;
      localStorage.setItem(
        'ordinaryUser',
        JSON.stringify(state.ordinaryUser),
      );
    },
    changeSupervisionUser(state, data) {
      state.supervisionUser = data;
      localStorage.setItem(
        'supervisionUser',
        JSON.stringify(state.supervisionUser),
      );
    },
    SET_OrdinaryLoggedIn(state, data) {
      state.ordinaryLoggedIn = data;
      localStorage.setItem('ordinaryLoggedIn', state.ordinaryLoggedIn);
    },
    SET_OrdinaryWsConnected(state, status) {
      state.ordinaryWsConnected = status
    },
    SET_SupervisionLoggedIn(state, data) {
      state.supervisionLoggedIn = data;
      localStorage.setItem('supervisionLoggedIn', state.supervisionLoggedIn);
    },
    SET_SupervisionWsConnected(state, status) {
      state.supervisionWsConnected = status
    }
  },
  actions: {
    handleRelogin({ commit }, accountType) {
      if (accountType === 'ordinary') {
        commit('SET_OrdinaryLoggedIn', false)
        // 可以在这里触发重新登录的UI提示
      } else {
        commit('SET_SupervisionLoggedIn', false)
        // 可以在这里触发重新登录的UI提示
      }
    },

    handleWebSocketMessage({ commit, state }, { accountType, message }) {
      // 根据消息类型处理不同的业务逻辑
      switch(message.type) {
        case 'userUpdate':
          if (accountType === 'ordinary') {
            commit('changeOrdinaryUser', message.data)
          } else {
            commit('changeSupervisionUser', message.data)
          }
          break
          // 其他消息类型...
      }
    }
  },
  getters: {
    ordinaryToken: () => localStorage.getItem('ordinaryToken'),
    supervisionToken: () => localStorage.getItem('supervisionToken')
  },
  modules: { chinaMap, echartsMap, login, news },
});
